import { writable } from "svelte/store"
import * as scannerApi from '../apis/scanner.aip'

export const scannerMsg = writable('');

export async function apiGetRefrnCode(mtrqlt) {
    try {
        const response = await scannerApi.apiGetRefrnCode(mtrqlt);
        if (response.status === 200) {
            return response.data.data.data['refrn_CODE'];
        } else {
            alert(response.data.msg)
        }
    } catch (e) {
        console.error('Error - store : ', e);
        alert('네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.')
    }
}

export async function apiWarehousing(item_code, item_nm, mtrqlt_code, mtrqlt, steel_thick, steel_wt, steel_mk) {
    try {

        const formData = {
            ITEM_CODE: item_code,
            ITEM_NM: item_nm,
            MTRQLT_CODE: mtrqlt_code,
            MTRQLT: mtrqlt,
            STEEL_THICK: steel_thick,
            STEEL_WT: steel_wt,
            STEEL_MK: steel_mk,
        };

        console.log(formData);
        const response = await scannerApi.apiWarehousing(formData);

        if (response.status === 200) {
            return true;
        } else {
            alert(response.data.msg)
            return false;
        }
    } catch (e) {
        console.error('Error - store : ', e);
        alert('네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.')
    }
}
